export const DEFAULT_PAGE_SIZE = 25
export const PAGE_SIZES = [10, 25, 50, 100]

export const PAGE_SIZE_KEY = 'EP_PORTAL_PAGE_SIZE'
export const PAGE_SIZE =
  Number(localStorage.getItem(PAGE_SIZE_KEY)) || DEFAULT_PAGE_SIZE
